export enum UtilityModalSelectEntityType {
  administrators = 'Administrators',
  computers = 'Computers',
  companies = 'Companies',
  tags = 'Tags'
}

export function splitArrayIntoChunks(idList: string[], chunkSize = 50): string[][] {
  const result = [];
  for (let i = 0; i < idList.length; i += chunkSize) {
    result.push(idList.slice(i, i + chunkSize));
  }
  return result;
}
